import { render, staticRenderFns } from "./xxcj.vue?vue&type=template&id=1562a170"
import script from "./xxcj.vue?vue&type=script&lang=js"
export * from "./xxcj.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!E:\\SAAS-QSX\\qsx-web\\node_modules\\_vue-loader@15.11.1@vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports